<template>
    <div class="modal animated fadeIn" id="register-vendor-form" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title w-100 font-weight-bold mt-3">Registrirajte salon</h4>
                <button onclick="document.getElementById('register-vendor-form').style.display='none';" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body mx-3"> 
                    <form id="login-form" @submit="createAccount($event)">
                        <!-- salon's name --> 
                        <div v-if="!closeForm">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-store-alt fa-1x"></i></span>
                                </div>
                                <input id="salon-name" v-model="salon.name" type="text" class="form-control" placeholder="Naziv salona" aria-label="name" aria-describedby="naziv salona" required>
                            </div>
                            <div class="form-group">
                                <label for="vrsta-salona">Vrsta salona</label>
                                <select v-model="salon.type" class="form-control" id="vrsta-salona">
                                    <option value="frizerski">frizerski salon</option>
                                    <option value="uljepsavanje">salon za uljepšavanje</option>
                                    <option value="masaze">Salon za masaže</option>
                                    <option value="spa">spa & wellness</option>
                                    <option value="tattoo">tattoo salon</option>
                                    <option value="drugo">drugo</option>
                                </select>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-map-marker fa-1x"></i></span>
                                </div>
                                <input id="salon-city" v-model="salon.city" type="text" class="form-control" placeholder="Grad" aria-label="salon-city" aria-describedby="naziv salona" required>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-envelope fa-1x"></i></span>
                                </div>
                                <input id="salon-email" v-model="salon.email" type="email" class="form-control" placeholder="E-adresa" aria-label="email" aria-describedby="basic-addon1" required>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-user fa-1x"></i></span>
                                </div>
                                <input id="salon-contact-person" v-model="salon.person" type="text" class="form-control" placeholder="kontakt osoba" aria-label="salon-contact-person" aria-describedby="kontakt osoba" required>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-phone fa-1x"></i></span>
                                </div>
                                <input id="salon-contact" v-model="salon.phone" type="text" class="form-control" placeholder="Kontakt broj" aria-label="salon-contact" aria-describedby="kontakt broj" required>
                            </div>
                            <div class="form-group">
                                <label for="vrijeme-kontakta">Vrijeme kontakta</label>
                                <select v-model="salon.time" class="form-control" id="vrijeme-kontakta">
                                    <option value="ujutro">ujutro</option>
                                    <option value="prije podne">prije podne</option>
                                    <option value="poslije podne">poslije podne</option>
                                    <option value="predvečer">predvečer</option>
                                </select>
                            </div>
                        </div>
                        <notify></notify>
                        
                        <button v-if="!closeForm" id="submit" type="submit" class="fs-btn dark text-uppercase btn-lg btn-block"> <loader v-if="loader" :color="'white'"></loader> <span v-if="!loader">Pošalji zahtjev</span></button>
                    </form>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <p>Imate korisnički račun? <a href="#" style="color:black;font-weight:bold" onclick="document.getElementById('register-vendor-form').style.display='none';" data-dismiss="modal" data-toggle="modal" data-target="#login-form">Prijavite se!</a></p>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapState , mapMutations } from 'vuex' 
export default {
    name:'',
    data:()=>{
       return {
            salon:{
                name:'',
                email:'',
                time:'',
                person:'',
                phone:'',
                city:'',
                type:'',
            },
            closeForm:false
       }
    },
    computed:{
        ...mapState({
            endpoint:(state)=>state.endpoint,
            notification:(state)=>state.notification,
            loader:(state)=>state.loader,
        }),
    },
    methods:{ 
        ...mapMutations({
            setNotif:'setNotification',
            setLoader:'setLoader',
            handleError:'handleError'
        }),
        createAccount(e){ 
            e.preventDefault();
            
            for(var item in this.salon){
                 if(this.salon[item].length == 0){
                    this.setNotif({type:2,msg:"All fields are required"});
                    return false;
                 }
            }  
            this.setLoader(true); 
            this.$store.dispatch('post',{details:this.salon,endpoint:this.endpoint+'vendor-signup'})
            .then((data)=>{
                console.log(data);
                this.setNotif({type:1,msg:data.data.msg});
                this.closeForm=true;
                this.setLoader(false);
            })
            .catch((error)=>{
                console.log(error.request);
                if(error.request != null){
                    this.$store.dispatch("handleError",error); 
                }
                this.setLoader(false);
            });
        }, 
    },
    created(){ 
    }
}
</script>